<template>
  <div class="puff-notice">
    <div class="puff-notice__bulb-icon-wrapper">
      <UseSvg icon="bulb" class="puff-notice__bulb-icon" />
    </div>
    <div class="puff-notice__notice-wrapper">
      Elevate Your Designs with Puff:
      <br class="puff-notice__br" />
      <a href="#image-design-tips" @click.stop>Tips to Get Started</a>
    </div>
  </div>
</template>

<script>
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "PuffNotice",
  components: { UseSvg }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.puff-notice {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-bottom: 12px;

  @include with-desktop {
    margin-bottom: 16px;
  }

  &__br {
    display: block;

    @include with-desktop {
      display: none;
    }
  }

  &__notice-wrapper {
    text-align: left;
  }

  &__bulb-icon-wrapper {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  &__bulb-icon {
    width: 24px;
    height: 24px;
    color: $white;
    background-color: $bulb-background;
    border-radius: 50%;
    padding: 2px;
  }
}
</style>
